// Safe reader for Vite environment variables.
//
// Why a wrapper: keeps direct `import.meta.env` reads out of feature code
// (per react-rewrite-plan.md §9.3) and gives every caller the same fallback
// behavior. Never throws and never logs the value — env values may contain
// secrets such as API keys.

export function readEnv(name: string, fallback?: string): string | undefined {
  // `import.meta.env` is provided by Vite at build time. Guard the access so
  // we degrade gracefully in non-Vite contexts (SSR, tests without setup).
  let raw: unknown;
  try {
    const env = import.meta.env as Record<string, unknown> | undefined;
    raw = env ? env[name] : undefined;
  } catch {
    raw = undefined;
  }

  if (typeof raw === 'string' && raw.length > 0) {
    return raw;
  }
  return fallback;
}

function basePath(): string {
  return (readEnv('BASE_URL', '/') ?? '/').replace(/\/$/, '');
}

export function appUrl(path: string): string {
  return `${basePath()}${path}`;
}

export function apiUrl(path: string): string {
  return `${(readEnv('VITE_API_BASE_URL', '/api') ?? '/api').replace(/\/$/, '')}${path}`;
}

export function relativeAppPath(pathname: string): string {
  const base = basePath();
  if (base && (pathname === base || pathname.startsWith(`${base}/`))) {
    return pathname.slice(base.length) || '/';
  }
  return pathname;
}
